"use strict";
/* tslint:disable:max-classes-per-file */
var $dyn;
(function ($dyn) {
    var serverForm;
    (function (serverForm) {
        function getPropertyName(modelFieldName) {
            var fieldNameTerminator = modelFieldName.lastIndexOf("_field");
            if (fieldNameTerminator !== -1) {
                return modelFieldName.substr(0, fieldNameTerminator);
            }
            return modelFieldName;
        }
        serverForm.getPropertyName = getPropertyName;
        function isModel(obj) {
            return obj && obj._properties ? true : false;
        }
        serverForm.isModel = isModel;
        var Model = /** @class */ (function () {
            function Model(parent) {
                var _this = this;
                this.parent = parent;
                this.propertyChanged = function () {
                    if (!_this._propertyChangedHost) {
                        _this._propertyChangedHost = new $dyn.eventHost();
                    }
                    return _this._propertyChangedHost;
                };
                this._properties = {};
                this.rowIndex = -1;
            }
            Object.defineProperty(Model.prototype, "collectionIndex", {
                get: function () {
                    if (!this._collectionIndex) {
                        this._collectionIndex = $dyn.observable();
                    }
                    return $dyn.value(this._collectionIndex);
                },
                set: function (value) {
                    if (!this._collectionIndex) {
                        this._collectionIndex = $dyn.observable(value);
                    }
                    else {
                        this._collectionIndex(value);
                    }
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(Model.prototype, "isActionable", {
                get: function () {
                    if (!this.parent) {
                        return false;
                    }
                    if (this.parent.UseReactGrid) {
                        return this.parent.activeRecord_mastertrackingid ? this.parent.activeRecord_mastertrackingid() === this.masterTrackingId : false;
                    }
                    return this.parent.selectedIndex() === this.collectionIndex;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(Model.prototype, "isSelected", {
                get: function () {
                    if (!this.parent) {
                        return false;
                    }
                    if (this.parent.UseReactGrid) {
                        return this.parent.internalActiveMasterTrackingId ? this.parent.internalActiveMasterTrackingId() === this.masterTrackingId : false;
                    }
                    return this.parent.selectedIndex() === this.collectionIndex;
                },
                set: function (value) {
                    if (!this.parent) {
                        return;
                    }
                    if (value) {
                        if (this.parent.UseReactGrid) {
                            this.parent.internalActiveMasterTrackingId(this.masterTrackingId);
                        }
                        this.parent.selectedIndex(this.collectionIndex);
                    }
                    else {
                        // only clear the value on the parent if this was the selected model
                        if (this.parent.UseReactGrid) {
                            if ($dyn.value(this.parent.internalActiveMasterTrackingId) === this.masterTrackingId) {
                                this.parent.internalActiveMasterTrackingId("");
                            }
                        }
                        if (this.parent.selectedIndex() === this.collectionIndex) {
                            this.parent.selectedIndex(-1);
                        }
                    }
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(Model.prototype, "isMarked", {
                get: function () {
                    if (this.parent && this.parent.UseReactGrid) {
                        return $dyn.util.stringToBoolean(this.getValue($dyn.reactGrid.ISMARKED_NAME));
                    }
                    var marked = this.parent && this.parent.markedIndexes && this.collectionIndex !== undefined && this.parent.markedIndexes()[this.collectionIndex];
                    return !!marked;
                },
                set: function (value) {
                    if (this.parent && this.parent.UseReactGrid) {
                        this.setValue($dyn.reactGrid.ISMARKED_NAME, value.toString(), false, this._formId);
                    }
                    else {
                        var markedIndexes = this.parent && this.parent.markedIndexes;
                        if (markedIndexes && this.collectionIndex !== undefined) {
                            markedIndexes()[this.collectionIndex] = value;
                        }
                    }
                },
                enumerable: false,
                configurable: true
            });
            Model.prototype.getPropertyNames = function () {
                if (this._properties) {
                    return Object.keys(this._properties);
                }
                return [];
            };
            Model.prototype.doesPropertyExist = function (propertyName) {
                if (propertyName === $dyn.reactGrid.ISSELECTED_NAME ||
                    propertyName === $dyn.reactGrid.ISMARKED_NAME ||
                    propertyName === $dyn.reactGrid.ISACTIONABLE_NAME ||
                    propertyName === $dyn.reactGrid.ISACTIVE_NAME ||
                    this._properties[propertyName] !== undefined) {
                    return true;
                }
                return false;
            };
            Model.prototype.removeProperty = function (propertyName) {
                if (propertyName !== $dyn.reactGrid.ISSELECTED_NAME &&
                    propertyName !== $dyn.reactGrid.ISMARKED_NAME &&
                    propertyName !== $dyn.reactGrid.ISACTIONABLE_NAME &&
                    this._properties[propertyName] !== undefined) {
                    delete this._properties[propertyName];
                }
            };
            Model.prototype.getValue = function (propertyName) {
                var property;
                if (this.parent && this.parent.UseReactGrid && propertyName === $dyn.reactGrid.ISSELECTED_NAME) {
                    property = this.isSelected;
                }
                else if (this.parent && this.parent.UseReactGrid && propertyName === $dyn.reactGrid.ISMARKED_NAME) {
                    property = $dyn.util.stringToBoolean($dyn.value(this._getProperty($dyn.reactGrid.ISMARKED_NAME)));
                }
                else if (this.parent && this.parent.UseReactGrid && propertyName === $dyn.reactGrid.ISACTIONABLE_NAME) {
                    property = this.isActionable;
                }
                else if (this.parent && this.parent.UseReactGrid && propertyName === $dyn.reactGrid.ISACTIVE_NAME) {
                    return this.parent.activeDataRowTrackingId ? this.parent.activeDataRowTrackingId() === this.masterTrackingId : false;
                }
                else {
                    property = this._getProperty(propertyName);
                }
                return $dyn.value(property);
            };
            Model.prototype.setValue = function (propertyName, value, raiseChanges, formId) {
                if (raiseChanges === void 0) { raiseChanges = false; }
                if (propertyName === $dyn.reactGrid.ISMARKED_NAME && !(this.parent && this.parent.UseReactGrid)) {
                    if (this.parent) {
                        if (this.collectionIndex !== undefined) {
                            this.parent.setMarked(this.collectionIndex, value === "true");
                        }
                    }
                }
                else {
                    var property = this._getProperty(propertyName);
                    var oldValue = property();
                    if (oldValue !== value) {
                        if (this.parent && this.parent.UseReactGrid) {
                            var groupHeaderInfo = void 0;
                            var groupTrackingId = "";
                            var masterDsName = "";
                            var isMasterDs = false;
                            // if model is within a group, get the group header info
                            if (formId && $dyn.reactGrid.GroupingManager.flightEnabled()) {
                                masterDsName = serverForm.getCollectionName($dyn.value(this.parent.masterDataSourceName));
                                isMasterDs = (masterDsName === this.collectionName);
                                if (isMasterDs) {
                                    groupTrackingId = this.getValue($dyn.reactGrid.PARENT_GROUP_KEY);
                                }
                                else {
                                    var relatedModel = this.getRelated(masterDsName, this.collectionIndex);
                                    if (relatedModel) {
                                        groupTrackingId = relatedModel.getValue($dyn.reactGrid.PARENT_GROUP_KEY);
                                    }
                                }
                                if (formId && masterDsName && groupTrackingId) {
                                    groupHeaderInfo = $dyn.reactGrid.GroupingManager.getGroup(formId, masterDsName, groupTrackingId);
                                }
                            }
                            // If the React grid is being used and the property indicates the column marking is changing, update the parent marked count
                            if (propertyName === $dyn.reactGrid.ISMARKED_NAME) {
                                if (oldValue !== undefined) {
                                    var adjustCountValue = $dyn.util.stringToBoolean(value) ? 1 : -1;
                                    $dyn.setValue(this.parent, "markedCount", $dyn.value(this.parent.markedCount) + adjustCountValue);
                                    if (groupHeaderInfo && isMasterDs) {
                                        $dyn.reactGrid.GroupingManager.adjustMarkedCountForHierarchy(formId, masterDsName, groupTrackingId, adjustCountValue);
                                    }
                                }
                            }
                            else if (this.parent.fieldsWithTotals && this.parent.fieldsWithTotals.indexOf(propertyName) >= 0) {
                                var adjustTotalValue = (oldValue === undefined) ? value : (value - oldValue);
                                this.parent._addFieldTotal(propertyName, adjustTotalValue);
                                if (groupHeaderInfo) {
                                    $dyn.reactGrid.GroupingManager.addFieldTotalForHierarchy(formId, masterDsName, groupTrackingId, this.collectionName, propertyName, adjustTotalValue);
                                }
                            }
                        }
                        property(value);
                        // if someone is listening to the model changes, raise the event. subscribers should create the event host if needed.
                        if (this._propertyChangedHost) {
                            this.addChange();
                        }
                        // Update the model version to the current $dyn.serverForm.ModelManager value
                        if (raiseChanges && this.masterTrackingId !== undefined && $dyn.serverForm.ModelManager.modelVersions[formId]) {
                            $dyn.serverForm.ModelManager.modelVersions[formId][this.masterTrackingId] = $dyn.serverForm.ModelManager.getLastVersion();
                        }
                        if (this.parent && (!this.parent._pendingCollectionChange || raiseChanges)) {
                            this.parent.addChange({ collectionIndex: this.collectionIndex, modelId: this.id, propertyName: propertyName });
                        }
                    }
                }
            };
            Model.prototype.deserialize = function (data, formId) {
                if (!data) {
                    return;
                }
                if ($dyn.debug.general) {
                    if (!this.dynPrevDescriptors) {
                        this.dynPrevDescriptors = [];
                    }
                    this.dynPrevDescriptors.push(data);
                }
                var parentUsingReactGrid = (this.parent && this.parent.UseReactGrid);
                this.id = data.Id;
                var raiseChange = true;
                if (data.Properties && data.Properties.MasterTrackingId !== undefined && data.Properties.MasterTrackingId !== null) {
                    if (!$dyn.serverForm.ModelManager.isValidTrackingId(data.Properties.MasterTrackingId)) {
                        data.Properties.MasterTrackingId = $dyn.serverForm.ModelManager.generateValidTrackingId();
                    }
                    if (data.Properties.MasterTrackingId !== this.masterTrackingId) {
                        if (!parentUsingReactGrid) {
                            // When tracking id changed, we treat model change as 'Create'. No need to raise a change in this case.
                            raiseChange = false;
                        }
                        this.masterTrackingId = data.Properties.MasterTrackingId;
                        // initialize version for new models
                        if (!$dyn.serverForm.ModelManager.modelVersions[formId]) {
                            $dyn.serverForm.ModelManager.modelVersions[formId] = {};
                        }
                        $dyn.serverForm.ModelManager.modelVersions[formId][this.masterTrackingId] = $dyn.serverForm.ModelManager.getLastVersion();
                    }
                }
                $dyn.serverForm.ModelManager.trackModel(this, formId);
                if (data.Name) {
                    this.collectionName = $dyn.serverForm.getCollectionName(data.Name);
                }
                if (data.Properties) {
                    // tslint:disable-next-line:forin
                    for (var propertyName in data.Properties) {
                        var value_1 = data.Properties[propertyName];
                        propertyName = $dyn.serverForm.getPropertyName(propertyName);
                        if (!parentUsingReactGrid || propertyName !== $dyn.reactGrid.ISMARKED_NAME || !this.parent.clientMarking) {
                            this.setValue(propertyName, value_1, raiseChange, formId);
                        }
                    }
                }
                // Only set UseReactGrid if it has not been set (should only be on _form model)
                if (this.collectionName && this.collectionName.lastIndexOf("_form") > -1 && this.getValue("UseReactGrid") === undefined) {
                    var useReactGrid = $dyn.util.isFlightEnabled($dyn.reactGrid.featureName) && (data.Properties && data.Properties.ForceLegacyGrid !== "1");
                    this.setValue("UseReactGrid", useReactGrid, false, formId);
                }
                if (data.ChildModelCollections) {
                    if (!this._relatedCollections) {
                        this._relatedCollections = {};
                    }
                    // tslint:disable-next-line:forin
                    for (var propertyName in data.ChildModelCollections) {
                        var serializedCollection = data.ChildModelCollections[propertyName];
                        propertyName = $dyn.serverForm.getCollectionName(propertyName);
                        serializedCollection.Name = propertyName;
                        var collection = this.getRelatedCollection(propertyName);
                        collection.deserialize(serializedCollection, formId);
                    }
                }
            };
            Model.prototype.getRelated = function (propertyName, collectionIndex) {
                if (propertyName === this.collectionName) {
                    return this;
                }
                else if (this.parent) {
                    return $dyn.value(this.parent.getRelated(propertyName, collectionIndex !== undefined ? collectionIndex : this.collectionIndex));
                }
                else {
                    var collection = $dyn.value(this.getRelatedCollection(propertyName));
                    if (collection) {
                        if (collectionIndex !== undefined) {
                            return (collectionIndex < 0 || collectionIndex >= collection.items().length) ? collection.valuesIfEmpty() : collection.items()[collectionIndex];
                        }
                        else {
                            if (collection.UseReactGrid) {
                                var activeTrackingId = $dyn.value(collection.internalActiveMasterTrackingId);
                                if (activeTrackingId) {
                                    var modelId = collection.name + "_" + activeTrackingId;
                                    return serverForm.ModelManager.getModel(modelId, this._formId);
                                }
                                else {
                                    return collection.valuesIfEmpty();
                                }
                            }
                            else {
                                // Active record model requested
                                var index = $dyn.value(collection.selectedIndex);
                                if ((index < 0 || index >= collection.items().length)) {
                                    return collection.activeRecordModel() ? collection.activeRecordModel() : collection.valuesIfEmpty();
                                }
                                else {
                                    // Active record model within items array
                                    return collection.items()[index];
                                }
                            }
                        }
                    }
                }
            };
            Model.prototype.getRelatedCollection = function (propertyName) {
                if (!this._relatedCollections) {
                    this._relatedCollections = {};
                }
                var relatedCollection = this._relatedCollections[propertyName];
                if (!relatedCollection) {
                    if (this.parent) {
                        return this.parent.getRelatedCollection(propertyName);
                    }
                    else {
                        relatedCollection = this._relatedCollections[propertyName] = new serverForm.ModelCollection(this, propertyName);
                    }
                }
                return relatedCollection;
            };
            Model.prototype.getVersion = function () {
                if (this.masterTrackingId === undefined || this._formId === undefined) {
                    return -1;
                }
                if (serverForm.ModelManager.modelVersions[this._formId] && serverForm.ModelManager.modelVersions[this._formId][this.masterTrackingId] !== undefined) {
                    return serverForm.ModelManager.modelVersions[this._formId][this.masterTrackingId];
                }
                return -1;
            };
            Model.prototype._getProperty = function (name, value) {
                var property = this._properties[name];
                if (!property) {
                    property = this._properties[name] = $dyn.observable(value);
                    property.__modelField = name;
                }
                return property;
            };
            Model.prototype.addChange = function () {
                $dyn.serverForm.UpdateModelManager.pushModelChange(this.id);
            };
            return Model;
        }());
        serverForm.Model = Model;
        // Patch breaking change in TypeScript 3.9 where property accessors mark the property as non-enumerable
        Object.defineProperty(Model.prototype, "collectionIndex", { enumerable: true });
    })(serverForm = $dyn.serverForm || ($dyn.serverForm = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=Model.js.map
